import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sidebarHoveredListing: null,
};

export const hoveredListingSlice = createSlice({
  name: "hoveredListing",
  initialState,
  reducers: {
    handleSidebarListingHover: (state, action) => {
      state.sidebarHoveredListing = action.payload;
    },
  },
});

export const { handleSidebarListingHover } = hoveredListingSlice.actions;

export default hoveredListingSlice.reducer;
